var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"room"},[(_vm.roomError)?_c('VideoRoomErrorPage'):(_vm.closed)?_c('VideoRoomClosed'):_c('VideoRoomEnter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }